module.exports = __webpack_public_path__ + "static/media/James-wong-rice-field.18c3ac4e.jpg";